import React from 'react';
import { TableCell } from '@mui/material';
import { convertColorToRGBA } from '../../utils/formatGradient';


class GridThemeCell extends React.Component {
    // gradient preview
    getParsedValue(value) {
        try {
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }
    render() {
        const value = this.getParsedValue(this.props.value);
        const gradientColorsPrivate = value?.gradientColorsPrivate || [];
        const gradientColorsShop = value?.gradientColorsShop || [];
        const gradientColorsAction = value?.gradientColorsAction || [];
        const colorPrivate = value?.colorPrivate;
        const colorShop = value?.colorShop;
        const colorAction = value?.colorAction;
        return (
            <TableCell key={this.props.field.id} align="left">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    {gradientColorsPrivate.length > 0 && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background: `linear-gradient(to right, ${gradientColorsPrivate
                                    .map((color) =>
                                        convertColorToRGBA(color)
                                    )
                                    .join(',')})`
                            }}
                        ></div>
                    )}
                    {colorPrivate && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background:
                                    convertColorToRGBA(colorPrivate)
                            }}
                        ></div>
                    )}
                    {gradientColorsShop.length > 0 && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background: `linear-gradient(to right, ${gradientColorsShop
                                    .map((color) =>
                                        convertColorToRGBA(color)
                                    )
                                    .join(',')})`
                            }}
                        ></div>
                    )}
                    {colorShop && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background:
                                    convertColorToRGBA(colorShop)
                            }}
                        ></div>
                    )}
                    {gradientColorsAction.length > 0 && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background: `linear-gradient(to right, ${gradientColorsAction
                                    .map((color) =>
                                        convertColorToRGBA(color)
                                    )
                                    .join(',')})`
                            }}
                        ></div>
                    )}
                    {colorAction && (
                        <div
                            style={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                background:
                                    convertColorToRGBA(colorAction)
                            }}
                        ></div>
                    )}
                </div>
            </TableCell>
        );
    }
}

export default GridThemeCell;
